import { render } from "./BiddingDetail.vue?vue&type=template&id=4b7d9684&scoped=true"
import script from "./BiddingDetail.vue?vue&type=script&lang=js"
export * from "./BiddingDetail.vue?vue&type=script&lang=js"

import "./BiddingDetail.vue?vue&type=style&index=0&id=4b7d9684&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b7d9684"

export default script